import React, { useRef, useState, useCallback, useEffect } from 'react'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const DatePickerComponent = ({ formik, config = {}, onChange, disabled, ...other }) => {

    const {
        values = {},
        errors = {},
        touched = {},
        // handleChange, 
        setFieldValue
    } = formik;

    const {
        name = "documentdate",
        label = "Document Date",
        hasError,
        helperText = '',
        renderValue, // render display way
    } = config

    const getValue = () => {

        if (renderValue) {
            return renderValue({ values })
        }

        // return values[name] ?? null

        const val = values[name]
        return val ? dayjs(val) : null
    }

    const getError = (name) => {

        if (hasError) {
            return hasError
        }

        // return Boolean(touched[name]) && Boolean(errors[name])
        return Boolean(errors[name])
    }

    const getHelperText = (name) => {

        if (helperText) {
            return helperText
        }

        // return touched[name] && errors[name]
        return errors[name]
    }

    const clearValue = (name) => {
        setFieldValue(name, null)

        // return ''
    }

    return (

        <LocalizationProvider dateAdapter={AdapterDayjs}>

            <DatePicker
                // autoFocus
                name={name}
                label={label}
                // view=""
                value={getValue()}
                format={"YYYY-MM-DD"}
                slotProps={{
                    textField: {
                        // error: Boolean(touched[name]) && Boolean(errors[name]),
                        error: getError(name),
                        helperText: getHelperText(name),
                        size: "small",
                        margin: "dense"
                    },
                    field: { clearable: true, onClear: () => clearValue(name) },
                }}
                onChange={(val) => {
                    // if (setFieldValue) {
                    //     setFieldValue(`${name}`, val, true)
                    // }

                    // if (onChange) {
                    //     onChange(val)
                    // }

                    const safeValue = val ?? null

                    if (setFieldValue) {
                        setFieldValue(name, safeValue, true)
                    }

                    if (onChange) { onChange(safeValue) }
                }}
                disabled={disabled}
                {...other}
            />

        </LocalizationProvider>
    )

}

export default DatePickerComponent;